import { apiProxyRequest } from "Api/apiProxyRequest";

export const resetRecoveryCodesRequest = (userId: string) =>
  apiProxyRequest<{ recovery_codes: string[] }>(
    `/users/${userId}/codes`,
    "POST"
  );
